import React, { FunctionComponent, ReactNode } from "react";
import Avatar from "@mui/material/Avatar";

type UserAvatarProps = {
  email?: string;
  children?: ReactNode;
};

export const UserAvatar: FunctionComponent<UserAvatarProps> = ({
  email,
  children,
}) => (
  <Avatar
    sx={{
      bgcolor: "primary.main",
      fontWeight: "bold",
      fontSize: "0.8rem",
      width: 30,
      height: 30,
    }}
  >
    {children || getInitialsFromEmailAddress(email)}
  </Avatar>
);

const getInitialsFromEmailAddress = (email?: string): string =>
  (email ?? "@")
    .split("@")[0]
    .split(".")
    .map((x) => x.charAt(0))
    .join("")
    .toUpperCase();
